export const appConstants = {
  feedbackAppRolePrefix: "CMF",
  toolboxAppRolePrefix: "TBX",
  threadV2AppRolePrefix: "THV2",
  wikiAppRolePrefix: "WIKI",
  builderAppRolePrefix: "CMB",
  knowldgeAppRolePrefix: "CMK",
  threadAppRolePrefix: "IM",
  viewerAppRolePrefix: "CMV",
  exeAppRolePrefix: "EXE",
  projectMAnagerAppRolePrefix: "PM_"
};
